import React from 'react';

import { Helmet } from 'react-helmet-async';
import { FormattedMessage, useIntl } from 'react-intl';
import classnames from 'classnames';
import { TopBar } from '@xingternal/top-bar';
import './global.css?global';
import { LocaleMessage } from '../../shared/LocaleMessage';
import styles from './styles.css';

const printPage = () => {
  window.print();
};

export default ({ id }: { id: string }) => {
  const { formatMessage } = useIntl();
  const link = formatMessage({ id: 'DATA_PROTECTION_LINK' });
  return (
    <div className={classnames(styles.container, 'printable')}>
      <FormattedMessage id="DATA_PROTECTION_LINK">
        {title => <Helmet title={`${title} | XING`} />}
      </FormattedMessage>
      <TopBar showOnLargerScreens={true} skipSearch title={link} />
      <a className="no-print" onClick={printPage}>
        <FormattedMessage id="BUTTON_PRINT" />
      </a>
      <LocaleMessage
        id={id}
        values={{
          a: (chunks: React.ReactNode) => (
            <a href="https://www.xing.com/privacy">{chunks}</a>
          ),
        }}
        tagName="div"
      />
    </div>
  );
};
